export default {
  get cacheEnabled () {
    return false
  },
  get apiUrl () {
    // let useSslDev = false
    // let useSslProd = true
    return 'https://2ris0v850m.execute-api.us-east-1.amazonaws.com/Prod/api'
    // return process.env.NODE_ENV === 'production'
    //   ? (useSslProd === true ? 'https://app-api.yakshof.com/api' : 'http://app-api.yakshof.com/api')
    //   : (useSslDev === true ? 'https://localhost:9443/api' : 'http://localhost:9000/api')
  },
  get marketApiUrl () {
    let useSslDev = false
    let useSslProd = true
    return process.env.NODE_ENV === 'production'
      ? (useSslProd === true ? 'https://app-api.yakshof.com/api/market' : 'http://app-api.yakshof.com/api/market')
      : (useSslDev === true ? 'https://localhost:9443/api/market' : 'http://localhost:9000/api/market')
  },
  get socketIOUrl () {
    let useSslDev = false
    let useSslProd = true
    return process.env.NODE_ENV === 'production'
      ? (useSslProd === true ? 'https://ykx-v2-socketio.herokuapp.com' : 'http://ykx-v2-socketio.herokuapp.com')
      : (useSslDev === true ? 'https://localhost:10443' : 'http://localhost:1337')
  },
  get useSocketIO () {
    return true
  },
  get defaultDateFormat () {
    return 'YYYY-MM-DD'
  }
}



// WEBPACK FOOTER //
// ./src/helpers/config.js